"use client";

import { useState, useEffect } from "react";
import { isClient } from "@/utils/browser";
import { defaultConfig } from "@/sites/config/domainConfigs";
import { DomainRouteConfig } from "@/sites/types";
import { DomainConfigManager } from "@/services/DomainConfigService/DomainConfigManager";

export const useDomainConfig = (): DomainRouteConfig => {
  const [config, setConfig] = useState<DomainRouteConfig>(defaultConfig);

  useEffect(() => {
    if (isClient()) {
      const hostname = window.location.hostname;
      setConfig(DomainConfigManager.get(hostname));
    }
  }, []);

  return config;
};

export const getServerDomainConfig = (hostname: string = ""): DomainRouteConfig => {
  return DomainConfigManager.get(hostname);
};
